import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getProfile } from './pages/sharedAPI/userApis';
import BigLoader from './components/BigLoader';

const isTestApp = process.env.REACT_APP_IS_TEST == "true";


const CompleteProfileMiddleWare = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [isProfileComplete, setIsProfileComplete] = useState(false);
  const location = useLocation();

  const isAuthenticated = localStorage.getItem('currentSubAccountId');

  useEffect(() => {
    const checkProfile = async () => {
      // 1. If not logged in, stop loading and let it render children 
      // (or redirect to login if this is also an Auth guard)
      if (!isAuthenticated) {
        setLoading(false);
        return;
      }

      // 2. Fetch the profile data
      try {
        const data = await getProfile();
        setIsProfileComplete(!!data?.result?.isProfileCompleted);
      } catch (error) {
        console.error("Failed to fetch profile", error);
      } finally {
        setLoading(false);
      }
    };
    if (isTestApp) {
      checkProfile();
    }
  }, [isAuthenticated]);
  if (isTestApp) {
    // 3. While waiting for the API, show a loader
    if (loading) {
      return <div style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'#ffffff'}}>
        <BigLoader />; // Replace with your Spinner component
      </div>
    }

    // 4. Prevent infinite redirect: if they are already going to /profile, let them through
    if (location.pathname === '/profile') {
      return children;
    }

    // 5. If authenticated but profile is incomplete, redirect
    if (isAuthenticated && !isProfileComplete) {
      return <Navigate to="/profile?activeTab=accountSetting" replace />;
    }

    return children;
  } else {
    return children;
  }

};

export default CompleteProfileMiddleWare;